import { render, staticRenderFns } from "./EditBetRowToto.vue?vue&type=template&id=f99fcc40&scoped=true"
import script from "./EditBetRowToto.vue?vue&type=script&lang=js"
export * from "./EditBetRowToto.vue?vue&type=script&lang=js"
import style0 from "./EditBetRowToto.vue?vue&type=style&index=0&id=f99fcc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99fcc40",
  null
  
)

export default component.exports